import * as React from 'react';
import { components } from 'react-select';

const ClearComparisonIndicatorRenderer = (props: any) => {
	return (
		<components.ClearIndicator
			{...props}
			innerProps={{
				...props.innerProps,
				'data-test': 'applyComparisonsClearSelectedComparison',
			}}
		/>
	);
};

export default ClearComparisonIndicatorRenderer;
